export const ATLAS_BASE_URL =
	process.env.CLOUD_ENV === 'staging'
		? 'https://home.stg.atlassian.com'
		: 'https://home.atlassian.com';
